<template>
  <div id="contenedor-main-listado-documentos-relacionados">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop
      :listadoDocumentosRelacionados="listadoDocumentosRelacionados"
      :soloLectura="soloLectura">
      </desktop>
    </template>
    <template v-else>
      <mobile
      :listadoDocumentosRelacionados="listadoDocumentosRelacionados">
      </mobile>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoDocumentosRelacionados',
  props: {
    listadoDocumentosRelacionados: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
